const WP_Component = wp.element.Component;

/**
 * Class Component
 */
export default class Component extends WP_Component {
  static attributes(attribute) {
    return {};
  }

  static getAttributes(attribute) {
    return this.attributes(attribute);
  }

  constructor() {
    super(...arguments);

    this.name = this.props.attr || this.constructor.name;
    this.default = this.constructor.getAttributes().default;

    this.setAttr = this.setAttr.bind(this);

    // Empty state to allow Components to have their own state
    this.state = {};
  }

  attr(key = null) {
    if (!key) key = this.name;

    if (this.props.context.attributes && this.props.context.attributes[key])
      return this.props.context.attributes[key];

    return this.default;
  }

  setAttr(value, key = null) {
    if (!key) key = this.name;

    this.props.context.setAttr({ [key]: value });
  }

  isView() {
    return this.props.context.isView();
  }

  render() {
    return null;
  }
}
